import { Store } from "../../store";
import { Component, OnInit } from "@angular/core";
import { ErrorReportingService } from "src/app/services/error-reporting.service";

@Component({
    selector: 'app-errors-search',
    templateUrl: './errors-search.component.html',
    styleUrls: ['./errors-search.component.scss']
})
export class ErrorsSearchComponent implements OnInit {

    errors$ = this.store.select<any[]>('errors');

    siteAreas = ['API', 'Basket', 'Checkout', 'Sign In', 'Admin', 'Public'];
    errorTypes = ['address-create', 'auth', 'card-create', 'courier', 'order-create'];

    params = {
        siteArea: '',
        errorType: '',
        searchText: '',
        limit: 8,
        limits: [8, 16, 24, 32, 64],
        page: 0,
        pages: 0,
        pageArray: [],
        totalRecords: 0,
        sort: 'error_reporting.createdAt DESC',
        sorts: [],
    };

    constructor(
        private store: Store,
        private errorReportingService: ErrorReportingService
    ) {
        this.search();
    }

    ngOnInit(): void {
    }

    search() {
        this.errorReportingService.search(this.params).subscribe(data => {
            this.store.set('errors', data.data.data);
            this.params.pages = Math.ceil(data.data.totalRecords / this.params.limit);
            this.params.totalRecords = data.data.totalRecords;
            this.params.pageArray = [];
            for (let i = 0; i < this.params.pages; i++) {
                this.params.pageArray.push(i);
            }
        });
    }

}
